// src/components/InTaxBaseComponent/hooks/useInTaxConfig.js
import React from "react";
import { InTaxAPI } from "../../../../../utils/firebase"; 
import { buildConfigIndex } from "../utils/configIndex";

/**
 * useInTaxConfig({ ttlMs, force, debug })
 *  - force: true => bypass cache (noCache) for debugging
 *  - debug: true => console.info/error breadcrumbs
 */
export default function useInTaxConfig({ ttlMs, force = false, debug = false } = {}) {
  const [state, setState] = React.useState({
    loading: true,
    error: null,
    index: null,
    raw: null,
  });

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (debug) console.info("[useInTaxConfig] start", { ttlMs, force });
        const raw = await InTaxAPI.fetchSystemInTaxConfigOnce({
          ttlMs,
          noCache: !!force,
        });
        if (cancelled) return;
        if (debug) console.info("[useInTaxConfig] raw:", raw);

        if (!raw || (Array.isArray(raw) && raw.length === 0)) {
          throw new Error("Empty income-tax system config");
        }

        const index = buildConfigIndex(raw);
        setState({ loading: false, error: null, index, raw });
        if (debug) console.info("[useInTaxConfig] built index OK");
      } catch (err) {
        if (debug) console.error("[useInTaxConfig] failed:", err);
        if (!cancelled) setState({ loading: false, error: err, index: null, raw: null });
      }
    })();
    return () => { cancelled = true; };
  }, [ttlMs, force, debug]);

  return state;
}
